import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Pagination,
  CircularProgress,
  InputAdornment
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { filterArticles } from "../../models/Article";
import ArticleCardList4 from "../Layout/ArticleCardList4";

const SearchPosts = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPosts, setTotalPosts] = useState(0);
  const limit = 8;

  const fetchPosts = async (search = searchTerm, pageNum = page) => {
    setLoading(true);
    try {
      const res = await filterArticles({
        page: pageNum,
        limit,
        title: search,
      });
      setPosts(Array.isArray(res?.data) ? res.data : []);
      setTotalPosts(res.total || 0);
    } catch (err) {
      throw err;
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchPosts();
  }, [page]);

  const handleSearch = () => {
    setPage(1);
    fetchPosts(searchTerm, 1);
  };

  return (
    <Box>
      {/* Banner + Search */}
      <Box
        sx={{
          mt:3, mb:3,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#bb0000",
            padding: 2,
            borderRadius: "40px",
            width: "80%",
            maxWidth: "600px",
          }}
        >
          <TextField
            fullWidth
            placeholder="Tìm kiếm bài viết..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
            InputProps={{
              sx: {
                backgroundColor: "white",
                borderRadius: "30px",
              },
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon
                    onClick={handleSearch}
                    sx={{ cursor: "pointer", color: "black" }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>

      {/* Results */}
      <Box p={3}>
        {loading ? (
          <Box display="flex" justifyContent="center">
            <CircularProgress />
          </Box>
        ) : (
          <>
            {posts.length > 0 && (
              <Typography fontWeight={700} mb={2}>
                Kết quả tìm kiếm
              </Typography>
            )}

            {posts.length === 0 ? (
              <Typography>Không tìm thấy bài viết nào.</Typography>
            ) : (
              <ArticleCardList4 articles={posts} />
            )}

            {totalPosts > limit && (
              <Box mt={4} display="flex" justifyContent="center">
                <Pagination
                  count={Math.ceil(totalPosts / limit)}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                />
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default SearchPosts;
